import './index.css'
import {
  VpModal,
  VpModalBody,
  VpModalCloseButton,
  VpModalDialog,
  VpModalHeader,
} from '@vtmn-play/react'
import React, { PropsWithChildren, ReactElement } from 'react'
import { twMerge } from 'tailwind-merge'

const dialogFullscreenClassName =
  'w-screen h-screen max-w-none! m-0! flex flex-col rounded-none bg-white'
const dialogVisibilityClassName = 'pointer-events-none opacity-0 hidden'
const headerClassName = 'pt-4 pb-0 flex items-center shrink-0'
const bodyClassName = 'pt-0 pb-4'

interface ModalProps extends PropsWithChildren {
  title?: ReactElement | string
  isOpen: boolean
  showCloseButton?: boolean
  handleOpen: () => void
  handleClose?: () => void
  closeOnClickOutside?: boolean
  fullScreen?: boolean
}

const Modal = ({
  title,
  isOpen,
  handleOpen,
  showCloseButton = true,
  handleClose,
  closeOnClickOutside = true,
  fullScreen = false,
  children,
}: ModalProps) => {
  const dialogClassName = twMerge(
    fullScreen && dialogFullscreenClassName,
    !fullScreen && 'w-full',
    fullScreen && !isOpen && dialogVisibilityClassName
  )

  return (
    <div
      className={twMerge(
        'fcs-modal',
        fullScreen && 'is-fullscreen',
        !isOpen && 'pointer-events-none'
      )}
    >
      <VpModal
        open={isOpen}
        onClose={handleClose}
        onOpen={handleOpen}
        closeOnClickOutside={closeOnClickOutside}
      >
        <VpModalDialog aria-label="TextModal dialog" className={dialogClassName}>
          {(title || showCloseButton) && (
            <VpModalHeader
              className={twMerge(
                headerClassName,
                fullScreen && 'pl-4! pr-4! w-full',
                !fullScreen && 'pl-5 pr-0'
              )}
            >
              {title && <span className="text-m font-semibold">{title}</span>}
              {showCloseButton && (
                <VpModalCloseButton data-testid="modal-close-button" className="ml-auto" />
              )}
            </VpModalHeader>
          )}
          <VpModalBody
            className={twMerge(
              bodyClassName,
              fullScreen && 'p-0 flex-1 overflow-hidden',
              !fullScreen && 'pl-5 pr-5'
            )}
          >
            {isOpen && children}
          </VpModalBody>
        </VpModalDialog>
      </VpModal>
    </div>
  )
}

export default Modal
